import { HttpClient, HttpResponse } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { Observable, Subject } from "rxjs";
import { map } from "rxjs/operators";
import { AutomapperService } from "../../../../../../core/automapper/automapper.service";
import { BASE_API_URL } from "../../../../../../core/environment.tokens";
import { AddressEditModel } from "./address-edit-model";

@Injectable()

export class AddressDetailEditService {
  reset = new Subject<any>();

  constructor(
    @Inject(BASE_API_URL) private readonly baseApiUrl: string,
    private readonly http: HttpClient,
    private automapper: AutomapperService,
    private route: ActivatedRoute
  ) { }

  getAddressGdFromPath(): number {
    return this.route.snapshot.firstChild.firstChild.firstChild.params.AddressGd;
  }

  resetAddress(addressId: number) {

    this.reset.next(addressId);
  }

  getAddressDetailsForEdit(): Observable<AddressEditModel> {
    const url = `${this.baseApiUrl}Address/AddressDetailsForEdit?addressId=${this.getAddressGdFromPath()}`;

    return this.http.get(url)
      .pipe(
        map(this.automapper.curry("default", "AddressEditModel"))
      );
  }

  updateAddressDetails(addressEditModel: AddressEditModel): Observable<number> {
    const url = `${this.baseApiUrl}Address/UpdateAddressDetails`;

    return this.http
    .post(url, addressEditModel)
    .pipe(
      map((response: any) => response as number));
  }
}
